import axios from 'axios'


// check Pre check-in data for current connector ( only applicable for hotel with multiple connectors )
const openPreCheckedInConnectorAtAppLaunch = async () => {
    let room = localStorage.getItem("room");
    let preCheckInDataHotelSpecificList = JSON.parse(localStorage.getItem("X_CHECKIN_PQ_DATA_HOTEL_SPECIFIC_LIST")) || [];

    for (const preCheckInDataHotelSpecific of preCheckInDataHotelSpecificList) {
        if (preCheckInDataHotelSpecific.preCheckedInGuestInfo && preCheckInDataHotelSpecific.preCheckedInGuestInfo !== "" && (!room || room === "null")) {
            if (!sessionStorage.getItem("handleOpenPreCheckedInConnectorAtAppLaunch")) {
                localStorage.setItem("X_CHECKIN_PQ_DATA", preCheckInDataHotelSpecific.preCheckedInGuestInfo);
                localStorage.setItem("ConnectorIP", preCheckInDataHotelSpecific.connectorIP);
                localStorage.setItem("clientId", preCheckInDataHotelSpecific.clientId);
            } else {
                const clientId = localStorage.getItem("clientId") || sessionStorage.getItem("clientId") || process.env.REACT_APP_CLIENT_CONFIG;

                if (preCheckInDataHotelSpecific.clientId == clientId) {
                    localStorage.setItem("X_CHECKIN_PQ_DATA", preCheckInDataHotelSpecific.preCheckedInGuestInfo);
                }
            }
        }
    }

    sessionStorage.setItem("handleOpenPreCheckedInConnectorAtAppLaunch", true);
}

openPreCheckedInConnectorAtAppLaunch();

export const app_connector_IP = localStorage.getItem("ConnectorIP") || sessionStorage.getItem("ConnectorIP") || process.env.REACT_APP_SERVER_IP;

let cdnMap = {};

try {  
  const rawMap = process.env.REACT_APP_HOST_TO_CDN_MAP;
  cdnMap = rawMap ? JSON.parse(rawMap) : {};
} catch (e) {
  cdnMap = {};
}

export const getCdnUrl = (CMSUrl, resourcePath) => {
  let baseUrl = cdnMap[CMSUrl] || CMSUrl;

  if (/^https?:\/\//i.test(resourcePath)) {
    try {
      const parsed = new URL(resourcePath);
      resourcePath = parsed.pathname + parsed.search;
    } catch (e) {
      return resourcePath;
    }
  }

  if (!baseUrl.endsWith("/") && !resourcePath.startsWith("/")) {
    baseUrl += "/";
  } else if (baseUrl.endsWith("/") && resourcePath.startsWith("/")) {
    resourcePath = resourcePath.slice(1);
  }

  return baseUrl + resourcePath;
};

export default axios.create({
  baseURL: (app_connector_IP.startsWith("http") || app_connector_IP.startsWith("https"))
  ? `${app_connector_IP}/Connector/rest`
  : process.env.REACT_APP_API_PROTOCOL == 'http' ? `http://${app_connector_IP}:8080/Connector/rest` : `https://${app_connector_IP}:8443/Connector/rest`
})

export const axiosPosBaseEndPoint =  axios.create({
    baseURL: (app_connector_IP.startsWith("http") || app_connector_IP.startsWith("https"))
    ? `${app_connector_IP}/posApiApplications/rest`
    : process.env.REACT_APP_API_PROTOCOL == 'http' ? `http://${app_connector_IP}:8080/posApiApplications/rest` : `https://${app_connector_IP}:8443/posApiApplications/rest`
  })